/**
 * Buscador — overlay de sugerencias (Gudslip, Figma 11911-5172 / 11911-4824).
 * AUTOCONTENIDO: localiza el form del header (.gudslip-header__search), se monta
 * dentro del header y añade el boton-lupa movil en .gudslip-header__actions
 * (el form del header esta oculto a <=989). No toca header.liquid.
 *
 * - Abrir: focus/teclear en el input del header (desktop) o tap en la lupa (movil).
 * - Cerrar: scrim, X, Escape, o al abrirse el sidecart (cart:updated).
 * - Sugerencias: Predictive Search API (/search/suggest.json) con fetch +
 *   debounce 250ms; aborta las peticiones obsoletas. Los productos se pintan
 *   con las clases .gudslip-card del tema (imagen + titulo + desc + precio +
 *   compare + %OFF); las "queries" sustituyen a las busquedas populares.
 * - Dinero: replica iurop-money a partir de la muestra data-money-sample
 *   (199999 centimos renderizados por Liquid en la moneda de la sesion):
 *   deduce prefijo/sufijo/separadores y recoloca el € a la derecha.
 * Va por atributos data-* (data-search-overlay, data-search-input, ...).
 */
(function () {
  'use strict';

  if (window.__gudslipSearchOverlay) return;
  window.__gudslipSearchOverlay = true;

  var DEBOUNCE_MS = 250;

  // Mismo glifo de lupa que las filas del snippet (fallback si la lista arranca vacia).
  var TERM_ICON = '<svg class="gudslip-search-overlay__term-icon" width="10" height="10" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M17.5 17.5L13.8833 13.8833" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/><path d="M9.16667 15.8333C12.8486 15.8333 15.8333 12.8486 15.8333 9.16667C15.8333 5.48477 12.8486 2.5 9.16667 2.5C5.48477 2.5 2.5 5.48477 2.5 9.16667C2.5 12.8486 5.48477 15.8333 9.16667 15.8333Z" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  var state = {
    root: null,
    headerInput: null,
    overlayInput: null,
    opener: null,
    timer: null,
    controller: null,
    token: 0,
    lastQuery: null,
    defaultTermsHtml: '',
    termIconHtml: TERM_ICON,
    promotionPrices: {},
    money: null
  };

  /* ---------------------------------------------------------------- utils */

  function qs(sel, ctx) { return (ctx || document).querySelector(sel); }

  function stripHtml(html) {
    if (!html) return '';
    try {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      return (doc.body.textContent || '').replace(/\s+/g, ' ').trim();
    } catch (err) {
      return '';
    }
  }

  function imageUrl(url, width) {
    if (!url) return '';
    return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=' + width;
  }

  /**
   * Deduce el formato de dinero de la muestra Liquid (199999 centimos):
   * "€1,999.99" → prefix "€", thousands ",", decimal ".", 2 decimales.
   * Igual que iurop-money, si hay € lo recoloca a la DERECHA ("1,999.99 €").
   */
  function parseMoneySample(sample) {
    var money = { prefix: '', suffix: ' €', thousands: '.', decimal: ',', decimals: 2 };
    if (!sample) return money;
    var m = sample.match(/^(.*?)1(\D?)999(\D)99(.*)$/); // con decimales
    if (m) {
      money.prefix = m[1];
      money.thousands = m[2] || '';
      money.decimal = m[3];
      money.suffix = m[4];
      money.decimals = 2;
    } else {
      m = sample.match(/^(.*?)199(\D?)999(.*)$/); // sin decimales (p. ej. JPY)
      if (m) {
        money.prefix = m[1];
        money.thousands = m[2] || '';
        money.decimal = '';
        money.decimals = 0;
        money.suffix = m[3];
      }
    }
    // Regla iurop-money: el simbolo € SIEMPRE a la derecha, con espacio.
    if ((money.prefix + money.suffix).indexOf('€') !== -1) {
      money.prefix = money.prefix.replace(/€/g, '').replace(/^\s+/, '');
      money.suffix = ' €';
    }
    return money;
  }

  function formatMoney(amount) {
    if (window.iuropChile && window.iuropChile.currency === 'CLP') return window.iuropFormatCLP(Number(amount) * 100);
    // amount: string decimal de la API ("24.95") o numero.
    var n = parseFloat(amount);
    if (isNaN(n)) return '';
    var money = state.money;
    var fixed = n.toFixed(money.decimals);
    var parts = fixed.split('.');
    var intPart = parts[0];
    if (money.thousands) {
      intPart = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, money.thousands);
    }
    var out = intPart;
    if (money.decimals > 0) out += money.decimal + parts[1];
    return money.prefix + out + money.suffix;
  }

  /* ------------------------------------------------------------- montaje */

  function findHeader() {
    var form = qs('.gudslip-header__search');
    if (form) {
      var header = form.closest('.gudslip-header');
      if (header) return header;
    }
    return qs('.gudslip-header');
  }

  function ensureMounted(root) {
    var header = findHeader();
    if (header && root.parentElement !== header) header.appendChild(root);
    return header;
  }

  /** Boton-lupa movil dentro de .gudslip-header__actions (el form esta oculto <=989). */
  function ensureMobileTrigger(header) {
    if (!header) return;
    var actions = qs('.gudslip-header__actions', header);
    if (!actions || qs('[data-search-open-trigger]', actions)) return;

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'gudslip-header__action gudslip-search-overlay__trigger';
    btn.setAttribute('data-search-open-trigger', '');
    btn.setAttribute('aria-label', state.root.getAttribute('data-label-open') || 'Search');
    btn.setAttribute('aria-expanded', 'false');

    // Reusa el glifo de lupa del propio header; si no existe, lo replica.
    var headerIcon = qs('.gudslip-header__search-btn svg', header);
    if (headerIcon) {
      btn.appendChild(headerIcon.cloneNode(true));
    } else {
      btn.innerHTML = '<svg class="gudslip-header__icon" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none" aria-hidden="true"><path d="M17.5 17.5L13.8833 13.8833" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/><path d="M9.16667 15.8333C12.8486 15.8333 15.8333 12.8486 15.8333 9.16667C15.8333 5.48477 12.8486 2.5 9.16667 2.5C5.48477 2.5 2.5 5.48477 2.5 9.16667C2.5 12.8486 5.48477 15.8333 9.16667 15.8333Z" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    }
    actions.insertBefore(btn, actions.firstChild);
  }

  /* ---------------------------------------------------------- abrir/cerrar */

  function isOpen() {
    return state.root && state.root.hasAttribute('data-open');
  }

  function open(opener) {
    if (!state.root || isOpen()) return;
    state.opener = opener || null;
    state.root.setAttribute('data-open', '');
    document.documentElement.setAttribute('data-search-open', '');
    document.querySelectorAll('[data-search-open-trigger]').forEach(function (t) {
      t.setAttribute('aria-expanded', 'true');
    });
  }

  function close() {
    if (!state.root || !isOpen()) return;
    state.root.removeAttribute('data-open');
    document.documentElement.removeAttribute('data-search-open');
    document.querySelectorAll('[data-search-open-trigger]').forEach(function (t) {
      t.setAttribute('aria-expanded', 'false');
    });
    if (state.timer) { clearTimeout(state.timer); state.timer = null; }
    if (state.controller) { state.controller.abort(); state.controller = null; }
    // Solo devolvemos el foco al boton-lupa: refocar el input del header
    // volveria a disparar su handler de focus y reabriria el overlay.
    if (
      state.opener &&
      state.opener.hasAttribute &&
      state.opener.hasAttribute('data-search-open-trigger') &&
      document.contains(state.opener)
    ) {
      state.opener.focus();
    }
    state.opener = null;
  }

  /* -------------------------------------------------------------- render */

  function setStatus(text) {
    var status = qs('[data-search-status]', state.root);
    if (status) status.textContent = text || '';
  }

  function swapHeading(el, label) {
    if (el && label) el.textContent = label;
  }

  function showDefaultState() {
    var root = state.root;
    var aside = qs('[data-search-aside-heading]', root);
    var main = qs('[data-search-main-heading]', root);
    var terms = qs('[data-search-terms]', root);

    swapHeading(aside, aside && aside.getAttribute('data-label-popular'));
    swapHeading(main, main && main.getAttribute('data-label-default'));
    if (terms && state.defaultTermsHtml) terms.innerHTML = state.defaultTermsHtml;

    // Sin busqueda: vuelve el aside (populares) y el layout de dos columnas.
    root.removeAttribute('data-querying');
    if (main) main.hidden = false;

    toggle('[data-search-default-cards]', true);
    toggle('[data-search-results]', false);
    toggle('[data-search-empty]', false);
    toggle('[data-search-viewall]', false);
    setStatus('');
  }

  function toggle(sel, show) {
    var el = qs(sel, state.root);
    if (el) el.hidden = !show;
  }

  /** Fila de sugerencia (mismo estilo que las busquedas populares). */
  function buildTerm(text, href) {
    var li = document.createElement('li');
    var a = document.createElement('a');
    a.className = 'gudslip-search-overlay__term';
    a.href = href;
    a.innerHTML = state.termIconHtml;
    var span = document.createElement('span');
    span.textContent = text;
    a.appendChild(span);
    li.appendChild(a);
    return li;
  }

  /** Card de producto de la API con las clases .gudslip-card del tema. */
  function buildCard(product) {
    var article = document.createElement('article');
    article.className = 'gudslip-card gudslip-search-overlay__card';

    var media = document.createElement('a');
    media.className = 'gudslip-card__media';
    media.href = product.url || '#';
    media.setAttribute('aria-label', product.title || '');

    var img = product.featured_image && product.featured_image.url ? product.featured_image.url : product.image;
    if (img) {
      var image = document.createElement('img');
      image.className = 'gudslip-card__img';
      image.loading = 'lazy';
      image.src = imageUrl(img, 600);
      image.srcset = imageUrl(img, 300) + ' 300w, ' + imageUrl(img, 600) + ' 600w';
      image.sizes = '(max-width: 749px) 50vw, 300px';
      image.alt = (product.featured_image && product.featured_image.alt) || product.title || '';
      media.appendChild(image);
    }
    var veil = document.createElement('span');
    veil.className = 'gudslip-card__overlay';
    veil.setAttribute('aria-hidden', 'true');
    media.appendChild(veil);
    article.appendChild(media);

    var info = document.createElement('div');
    info.className = 'gudslip-card__info';

    var title = document.createElement('a');
    title.className = 'gudslip-card__title';
    title.href = product.url || '#';
    title.textContent = product.title || '';
    info.appendChild(title);

    var descText = stripHtml(product.body);
    if (descText) {
      var desc = document.createElement('p');
      desc.className = 'gudslip-card__desc';
      desc.textContent = descText;
      info.appendChild(desc);
    }

    var prices = document.createElement('div');
    prices.className = 'gudslip-card__prices';
    var priceNum = parseFloat(product.price || product.price_min);
    var promotionCents = state.promotionPrices[String(product.id)];
    if (typeof promotionCents === 'number' && Number.isFinite(promotionCents)) {
      priceNum = promotionCents / 100;
    }
    var price = document.createElement('span');
    price.className = 'gudslip-card__price';
    price.textContent = formatMoney(priceNum);
    prices.appendChild(price);

    // La API predictiva solo expone agregados por producto. Compara siempre
    // price_min con compare_at_price_min: usar el máximo mezclaría variantes
    // distintas y podría fabricar descuentos desproporcionados.
    var compareNum = parseFloat(product.compare_at_price_min);
    if (!isNaN(compareNum) && !isNaN(priceNum) && compareNum > priceNum) {
      var compare = document.createElement('s');
      compare.className = 'gudslip-card__compare';
      compare.textContent = formatMoney(compareNum);
      prices.appendChild(compare);

      var off = document.createElement('span');
      off.className = 'gudslip-card__off';
      off.textContent = window.iuropChile.discount.replace('__PERCENT__', Math.round(((compareNum - priceNum) / compareNum) * 100));
      prices.appendChild(off);
    }
    info.appendChild(prices);
    article.appendChild(info);
    return article;
  }

  function renderResults(query, resources) {
    var root = state.root;
    var results = (resources && resources.results) || {};
    var products = results.products || [];
    var queries = results.queries || [];
    var searchUrl = root.getAttribute('data-search-url') || '/search';

    // Columna izquierda: sugerencias ↔ populares
    var aside = qs('[data-search-aside-heading]', root);
    var terms = qs('[data-search-terms]', root);
    if (queries.length && terms) {
      swapHeading(aside, aside && aside.getAttribute('data-label-suggestions'));
      terms.innerHTML = '';
      queries.forEach(function (q) {
        terms.appendChild(buildTerm(q.text, searchUrl + '?q=' + encodeURIComponent(q.text)));
      });
    } else {
      swapHeading(aside, aside && aside.getAttribute('data-label-popular'));
      if (terms && state.defaultTermsHtml) terms.innerHTML = state.defaultTermsHtml;
    }

    // Columna derecha: productos ↔ vacio
    var main = qs('[data-search-main-heading]', root);
    var container = qs('[data-search-results]', root);
    var viewall = qs('[data-search-viewall]', root);

    // Buscando: el aside (populares) se oculta y las cards pasan a ocupar TODO
    // el ancho, en UNA sola fila, con el enlace "ver mas resultados" debajo.
    root.setAttribute('data-querying', '');

    if (products.length && container) {
      if (main) main.hidden = false;
      swapHeading(main, main && main.getAttribute('data-label-results'));
      container.innerHTML = '';
      var perRow = parseInt(root.getAttribute('data-row-limit'), 10) || 4;
      products.slice(0, perRow).forEach(function (p) { container.appendChild(buildCard(p)); });
      toggle('[data-search-default-cards]', false);
      toggle('[data-search-results]', true);
      toggle('[data-search-empty]', false);
      if (viewall) {
        viewall.href = searchUrl + '?q=' + encodeURIComponent(query);
        viewall.hidden = false;
      }
      setStatus('');
    } else {
      // Sin productos: mensaje nombrando la búsqueda + recomendados (1 fila).
      // El propio mensaje introduce las cards, así que el título ("Bestsellers")
      // sobra: se oculta para que no diga dos cosas a la vez.
      toggle('[data-search-results]', false);
      toggle('[data-search-default-cards]', true);
      toggle('[data-search-empty]', true);
      toggle('[data-search-viewall]', false);

      var empty = qs('[data-search-empty]', root);
      if (empty) {
        var tpl = empty.getAttribute('data-label-empty-for');
        if (tpl) empty.textContent = tpl.replace('__Q__', query);
      }
      if (main) main.hidden = true;
      setStatus(empty ? empty.textContent : '');
    }
  }

  /* --------------------------------------------------------------- fetch */

  function runSearch(query) {
    var root = state.root;
    var base = root.getAttribute('data-predictive-url') || '/search/suggest';
    var limit = parseInt(root.getAttribute('data-suggest-limit'), 10) || 6;
    var url = base + '.json?q=' + encodeURIComponent(query) +
      '&resources[type]=product,query' +
      '&resources[limit]=' + limit +
      '&resources[options][unavailable_products]=last';

    if (state.controller) state.controller.abort();
    state.controller = window.AbortController ? new AbortController() : null;
    var token = ++state.token;

    setStatus(root.getAttribute('data-label-searching') || '');

    fetch(url, {
      signal: state.controller ? state.controller.signal : undefined,
      headers: { Accept: 'application/json' }
    })
      .then(function (res) {
        if (!res.ok) throw new Error('predictive search ' + res.status);
        return res.json();
      })
      .then(function (data) {
        if (token !== state.token) return; // respuesta obsoleta
        state.lastQuery = query;
        renderResults(query, data && data.resources);
      })
      .catch(function (err) {
        if (err && err.name === 'AbortError') return;
        if (token !== state.token) return;
        // Fallo de red/API: se queda el estado por defecto (el submit sigue funcionando).
        showDefaultState();
      });
  }

  function scheduleSearch(value) {
    var query = (value || '').trim();
    if (state.timer) clearTimeout(state.timer);
    if (!query) {
      state.lastQuery = null;
      state.token++; // invalida cualquier peticion en vuelo
      if (state.controller) { state.controller.abort(); state.controller = null; }
      showDefaultState();
      return;
    }
    if (query === state.lastQuery) return;
    state.timer = setTimeout(function () { runSearch(query); }, DEBOUNCE_MS);
  }

  /* ------------------------------------------------------------- eventos */

  function syncInputs(from) {
    var value = from.value;
    if (state.headerInput && state.headerInput !== from && state.headerInput.value !== value) {
      state.headerInput.value = value;
    }
    if (state.overlayInput && state.overlayInput !== from && state.overlayInput.value !== value) {
      state.overlayInput.value = value;
    }
  }

  function bindHeaderInput() {
    var form = qs('.gudslip-header__search');
    if (!form) return;
    var input = qs('input[name="q"]', form);
    if (!input || input.__gudslipSearchBound) return;
    input.__gudslipSearchBound = true;
    state.headerInput = input;

    input.addEventListener('focus', function () { open(input); });
    input.addEventListener('input', function () {
      open(input);
      syncInputs(input);
      scheduleSearch(input.value);
    });
  }

  function bindOverlay() {
    var root = state.root;
    var input = qs('[data-search-input]', root);
    state.overlayInput = input;

    if (input && !input.__gudslipSearchBound) {
      input.__gudslipSearchBound = true;
      input.addEventListener('input', function () {
        syncInputs(input);
        scheduleSearch(input.value);
      });
    }
  }

  function bindDocument() {
    if (document.__gudslipSearchDocBound) return;
    document.__gudslipSearchDocBound = true;

    document.addEventListener('click', function (event) {
      var openTrigger = event.target.closest('[data-search-open-trigger]');
      if (openTrigger) {
        event.preventDefault();
        if (isOpen()) { close(); return; }
        open(openTrigger);
        if (state.overlayInput) state.overlayInput.focus();
        return;
      }
      var closeTrigger = event.target.closest('[data-search-close]');
      if (closeTrigger && state.root && state.root.contains(closeTrigger)) {
        event.preventDefault();
        close();
      }
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && isOpen()) close();
    });

    // Fast-add desde una card del overlay → el sidecart se abre encima: cerramos.
    document.addEventListener('cart:updated', function () {
      if (isOpen()) close();
    });

    // Theme editor: el header puede re-renderizarse con el overlay dentro.
    document.addEventListener('shopify:section:load', function () {
      window.setTimeout(init, 0);
    });
  }

  /* ---------------------------------------------------------------- init */

  function init() {
    var root = qs('[data-search-overlay]');
    if (!root) return;
    if (root === state.root && document.contains(root) && !root.hidden) return;

    state.root = root;
    var promotionData = qs('[data-search-one-time-prices]', root);
    try { state.promotionPrices = promotionData ? JSON.parse(promotionData.textContent) : {}; }
    catch (err) { state.promotionPrices = {}; }
    state.money = parseMoneySample(root.getAttribute('data-money-sample'));

    var header = ensureMounted(root);
    ensureMobileTrigger(header);
    bindHeaderInput();
    bindOverlay();
    bindDocument();

    var terms = qs('[data-search-terms]', root);
    if (terms) {
      state.defaultTermsHtml = terms.innerHTML;
      var icon = qs('.gudslip-search-overlay__term-icon', terms);
      if (icon) state.termIconHtml = icon.outerHTML;
    }

    // Visible para CSS (los estados van por [data-open]); sin JS queda oculto.
    root.hidden = false;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
